import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, Camera, MessageCircle, Flame, Trophy, X } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const STEPS = [
  { icon: Sparkles, bg: "bg-coral text-white", n: 1 },
  { icon: Camera, bg: "bg-mint", n: 2 },
  { icon: MessageCircle, bg: "bg-lavender", n: 3 },
  { icon: Sparkles, bg: "bg-butter", n: 4 },
  { icon: Flame, bg: "bg-sky", n: 5 },
];

export default function OnboardingTour() {
  const navigate = useNavigate();
  const { t } = useI18n();
  const [step, setStep] = useState(() => (localStorage.getItem("fluent_tour_done") ? -1 : 0));

  if (step < 0) return null;
  const s = STEPS[step];
  const Icon = s.icon;
  const last = step === STEPS.length - 1;

  const finish = () => { localStorage.setItem("fluent_tour_done", "1"); setStep(-1); };

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-ink/60 backdrop-blur-sm" data-testid="onboarding-tour">
        <motion.div key={step} initial={{ opacity: 0, y: 20, scale: 0.95 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0 }}
          className="nb-card p-0 max-w-sm w-full overflow-hidden shadow-hard-lg">
          <div className={`${s.bg} p-6 border-b-2 border-ink relative`}>
            <button onClick={finish} className="absolute top-4 end-4" data-testid="tour-skip" aria-label={t("tour.skip")}><X className="w-5 h-5" /></button>
            <div className="w-14 h-14 rounded-2xl border-2 border-ink bg-white flex items-center justify-center">
              <Icon className="w-7 h-7 stroke-[2.5] text-ink" />
            </div>
            <h2 className="font-cabinet font-extrabold text-2xl mt-4">{t(`tour.t${s.n}`)}</h2>
          </div>
          <div className="p-6 bg-white">
            <p className="text-gray-700">{t(`tour.b${s.n}`)}</p>
            <div className="flex items-center justify-center gap-2 mt-6">
              {STEPS.map((_, i) => (
                <span key={i} className={`h-2 rounded-full border-2 border-ink transition-all ${i === step ? "w-6 bg-coral" : "w-2 bg-white"}`} />
              ))}
            </div>
            <div className="flex gap-3 mt-6">
              {step > 0 && <button onClick={() => setStep(step - 1)} className="nb-btn-outline px-5 py-3" data-testid="tour-back">{t("tour.back")}</button>}
              {last ? (
                <button onClick={() => { finish(); navigate("/today"); }} className="nb-btn-primary flex-1 py-3" data-testid="tour-finish">
                  <Trophy className="w-5 h-5" /> {t("tour.start")}
                </button>
              ) : (
                <button onClick={() => setStep(step + 1)} className="nb-btn-primary flex-1 py-3" data-testid="tour-next">{t("tour.next")}</button>
              )}
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
}
